// removed by extract-text-webpack-plugin
module.exports = {"loadingResults":"Loader_loadingResults__2IBv","appLogo":"Loader_appLogo__b98x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.scss
// module id = 538
// module chunks = 0